import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { fetchAccountDetails } from '../../../../submodules/shared/actions/account-actions';

import LabDisplay from './lab-display';

const mapStateToProps = (reducers) => {
    return reducers;
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        fetchAccountDetails,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(LabDisplay);
